import { Button, Dialog } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useCallback, useEffect, useState } from "react";
import CreateBaseClientModal from "../../Components/Modal/CreateBaseClientModal";
import Breadcrumb from "../../Components/Navigation/Breadcrumbs/Breadcrumbs";
import Signifier from "../../Components/Signifier";
import BaseClientTableCell from "../../Components/Table/BaseClientTableCell";
import SortableTable from "../../Components/Table/SortableTable";
import { getClients } from "../../Services/API/BaseClientManagement";
import { useClientBillingTiers } from "../../Helpers/billingTierDefaultPricing";

const useStyles = makeStyles((theme) => ({
  button: {
    background: theme.palette.primary.main,
    marginTop: "20px",
    width: "98%",
  },
  createButton: {
    background: theme.palette.primary.main,
    color: "white",
    marginRight: "3%",
    width: "200px",
    "&:hover": {
      background: theme.palette.primary.main,
      color: "white",
    },
    [theme.breakpoints.down("sm")]: {
      width: "98%",
      height: 32,
    },
  },
  buttonContainer: {
    flex: 1, 
    flexDirection: "row", 
    display: "flex", 
    maxHeight: 32, 
    marginBottom: -35, 
    justifyContent: "flex-end",
    [theme.breakpoints.down("sm")]: {
      width: "98%",
      height: 32,
      flex: 0,
      display: "inline-block",
      marginBottom: 10,
    },
  }
}));

export default function BaseClientManagementPage() {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [showSignifier, setShowSignifier] = useState(false);
  const [showError, setShowError] = useState(false);
  const [createProcessing, setCreateProcessing] = useState(false);

  useClientBillingTiers();

  const columns = [
    { label: "Name", propName: "clientName" },
    { label: "Date Created", propName: "dateCreated" },
    { label: "Date Last Updated", propName: "dateLastUpdated" },
  ];

  const loadClients = useCallback(() => {
    setLoading(true);
    setLoadError(false);
    return getClients()
      .then((res) => {
        setData(res);
      })
      .catch((err) => {
        // Surface a retryable error state instead of loading forever.
        console.error("Failed to load clients:", err);
        setLoadError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    loadClients();
  }, [loadClients]);

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message="Client Created"
        error={showError}
        errorMessage="Error Creating Client"
      />
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">Clients</h1>
        <div className={classes.buttonContainer}>
          <Button
            className={classes.createButton}
            type="submit"
            variant="contained"
            color="primary"
            onClick={() => setOpenModal(true)}
            data-test="create-base-client-button"
          >
            Create Client
          </Button>
        </div>
        <SortableTable
          columns={columns}
          tableData={data}
          rowComponent={BaseClientTableCell}
          loading={loading}
          error={loadError}
          onRetry={loadClients}
          defaultSortIndex={0}
        />
      </div>
      <Dialog
        maxWidth="sm"
        fullWidth
        open={openModal}
        onClose={(event, reason) => {
          if (!createProcessing && reason === "backdropClick") {
            setOpenModal(false);
          }
        }}
      >
        <CreateBaseClientModal
          openModal={setOpenModal}
          setData={setData}
          setShowSignifier={setShowSignifier}
          setShowError={setShowError}
          createProcessing={createProcessing}
          setCreateProcessing={setCreateProcessing}
        />
      </Dialog>
    </>
  );
}
